import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Col, Card, CardBody, CardFooter, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { dateFormat } from '../../../../util/date';
import { truncate } from '../../../../util/text';

import { REVIEW_SCORE_MAX } from '../../ReviewActions';

import FontCustom from '../../../../components/Content/FontCustom';

const ReviewListItem = ({ review, isSummary }) => {
    // const wrapper = forwardRef(null);

    const height = '250px';

    const getYoutubeId = link => {
        let id = '';
        link = `${link}`.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if(link[2] !== undefined) {
            id = link[2].split(/[^0-9a-z_-]/i);
            return id[0];
        }
        return link;
    };

    const renderLink = () => {
        if(review.link && `${review.link}`.includes('youtube')) {
            // const elt = wrapper.current;
            const id = getYoutubeId(review.link);
            return <iframe width="100%" height={height} title={id} name={id} src={`https://youtube.com/embed/${id}`} frameBorder="0" />;
        }
        return null;
    };

    const renderText = () => {
        return isSummary ? `${truncate(review.text)}...` : review.text;
    };

    const link = renderLink();

    return (
        <Col xs="12" md={{ size: 6, offset: isSummary ? 3 : 0 }}>
            <Card className={classnames(!isSummary && ['border', 'border-light'])}>
                {!isSummary && review.link && link && (
                    <div className="card-img-top" style={{ minHeight: height }}>
                        {link}
                    </div>
                )}
                <CardBody className="m-1">
                    <div style={{ overflow: 'auto', maxHeight: '300px' }}>
                        <div className="review-score m-auto text-center" style={{ width: '8em' }}>
                            {Array(REVIEW_SCORE_MAX).fill(1).map((i, index) => index + 1).map(score => <span key={score} className={classnames('d-inline-block', 'w-20', review.score >= score && 'text-warning')}><FontCustom name="star" size="2" /></span>)}
                        </div>
                        <span className="d-block my-2 text-center">
                            <strong>{review.name}</strong>, <FormattedMessage id="dateThe" defaultMessage="the {date}" values={{ date: dateFormat(review.dates.creation, 'L') }} />
                        </span>
                        {review.title && <span className="d-block h6 text-center">{review.title}</span>}
                        {renderText()}<br />
                        {!isSummary && review.link && !link && <Button color="link" tag="a" href={review.link} className="mt-2" target="_blank"><FormattedMessage id="reviewLinkViewButton" defaultMessage="View the link" /></Button>}
                    </div>
                </CardBody>
                {!isSummary && review.answer && (
                    <CardFooter>
                        <span className="d-block text-center font-weight-bold"><FormattedMessage id="reviewAnswer" defaultMessage="Answer of Atremoplus" /></span>
                        <div style={{ overflow: 'auto', maxHeight: '200px' }}>
                            {review.answer}
                        </div>
                    </CardFooter>
                )}
            </Card>
        </Col>
    );
};

ReviewListItem.defaultProps = {
    isSummary: false,
};

ReviewListItem.propTypes = {
    review: PropTypes.object.isRequired,
    isSummary: PropTypes.bool,
};

export default ReviewListItem;
